import React from 'react';

var TUXDialogImage = function TUXDialogImage(props) {
  if (props.variant === 'icon') {
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-24 mb-16 flex justify-center",
      style: {
        fontSize: 48
      }
    }, props.icon);
  }

  if (props.variant === 'banner') {
    return /*#__PURE__*/React.createElement("img", {
      className: "w-full",
      src: props.src,
      alt: props.alt
    });
  }

  return null;
};

export { TUXDialogImage };
//# sourceMappingURL=TUXDialogImage.js.map
